import React, { memo } from 'react'
import { Box } from '@mui/material'

import Popup from '../../shared/popup/Popup'
import {
  pointsConversionRate,
  pointsToCryptoConversion
} from '../../../util/component.helpers'
import {
  exchangeProviderLabel,
  selectExchangeRate
} from '../../../util/pointsExchange.helpers'
import { formatTicks } from '../../../util/string.helpers'
import ExchangeProviderIcon from '../../shared/exchangeProviderCard/ExchangeProviderIcon'
import DisplayValue from '../../shared/text/DisplayValue'

const ReceiveExternalRewards = ({
  reward,
  cryptoExchanges,
  title,
  description,
  provider,
  onSubmit,
  onCancel,
  t,
  ...restProps
}) => {
  const name = provider?.name
  const isCrypto = provider?.isCrypto
  const symbol = provider?.symbol
  return (
    <Popup
      title={title}
      description={description}
      onFormSubmit={onSubmit}
      onCancel={onCancel && onCancel}
      cancelLabel={t('common.cancel')}
      customIcon={<ExchangeProviderIcon provider={provider} iconSize={100} />}
      {...restProps}
    >
      <Box sx={{ py: { xs: 1, md: 2 } }}>
        <DisplayValue
          title={formatTicks(
            isCrypto
              ? pointsToCryptoConversion(
                  reward,
                  provider.exchangeOfframp,
                  selectExchangeRate(cryptoExchanges, provider)
                )
              : pointsConversionRate(reward, provider)
          )}
          desc={exchangeProviderLabel({ name, symbol })}
        />
      </Box>
    </Popup>
  )
}

export default memo(ReceiveExternalRewards)
